import { ActionIcon, Alert, Button, Flex, Group } from "@mantine/core";
import { IconArrowsDiagonal } from "@tabler/icons-react";
import { STYLE, OrderDesignPreview } from "@jasper/shared";
import { MantineJasperThemeProvider } from "@jasper/forms";
import { DesignRejectionModal } from "./DesignRejectionModal";
import { useDesignReviewActions } from "./useDesignReviewActions";

interface Props {
  orderId: string;
  refetchOrder?: () => Promise<unknown>;
}

export const OrderDesignReview = ({ orderId, refetchOrder }: Props) => {
  const review = useDesignReviewActions({ orderId, refetchOrder });
  const { openedOrderDesign, requestedOrderDesign, isReviewing } = review;

  if (requestedOrderDesign) {
    return (
      <Flex justify="center" align="center" h="100%">
        <Alert color="gray">
          {
            "Le design est en cours de préparation par le laboratoire. Vous serez notifié dès qu'il sera prêt pour revue."
          }
        </Alert>
      </Flex>
    );
  }

  if (!openedOrderDesign) {
    return (
      <Flex justify="center" align="center" h="100%">
        <Alert color="yellow">
          Aucune conception de prothèse en attente de revue pour cette commande.
        </Alert>
      </Flex>
    );
  }

  return (
    <>
      <DesignRejectionModal review={review} />
      <OrderDesignPreview
        orderDesignId={openedOrderDesign.id}
        interactionsEnabled={!review.rejection.isOpened}
        bottomOverlay={{
          render: ({ fullscreen, openFullscreenModal }) => {
            return (
              <MantineJasperThemeProvider>
                <Flex align="center" style={{ width: "100%" }}>
                  <div style={{ flex: 1 }} />

                  <Group>
                    <Button
                      color={STYLE.primary}
                      loading={isReviewing}
                      onClick={review.validate}
                    >
                      Valider
                    </Button>
                    <Button
                      color="red"
                      loading={isReviewing}
                      onClick={review.rejection.open}
                    >
                      Rejeter
                    </Button>
                  </Group>

                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    {!fullscreen && (
                      <ActionIcon
                        color={STYLE.primary}
                        key="zoom"
                        variant="subtle"
                        onClick={openFullscreenModal}
                      >
                        <IconArrowsDiagonal />
                      </ActionIcon>
                    )}
                  </div>
                </Flex>
              </MantineJasperThemeProvider>
            );
          },
        }}
      />
    </>
  );
};
